// route/COM001L1.js

import React from "react";
import {Outlet} from 'react-router-dom';

const COM001L2 = () => {

    return (
            <div className="root_wrap" style={{ height: '100vh', display: 'flex', flexDirection: 'column'}}>
{/*                <COM001F1 isUserInfoPg={false}/>*/}
                <div style={{flex: 1}}>
                    <Outlet />
                </div>
                {/*<COM002F1 />*/} {/* Footer */}
            </div>
    );
};

export default COM001L2;







